import { isMobilePurpleUseragent, makeElement } from "../../../common/Utils";
import { AbsSocial } from "./AbsSocial";
import { ga360 } from '../socials/GA360';

export class Line extends AbsSocial {

    name: SocialName = 'line';
    dataContents = ga360.dataContents.line;
    dataArea = ga360.dataArea.common;

    constructor(protected ElShareItemWrap: HTMLElement, protected option: ShareOption){
        super(ElShareItemWrap, option);

        this.init();
    }

    async callShare() {
      const targetUrl = 'https://lineit.line.me/share/ui?url=' + encodeURIComponent(this.option.shareUrl);

      if(isMobilePurpleUseragent()){
          location.href = `ncmtalk://external?url=${targetUrl}`;
      }else{
          window.open(targetUrl, '_blank');
      }
    }
}
